/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit'

export const initModalState: Redux.ModalState = {
  activeModalType: undefined,
}

function setActiveModalTypeAction(
  state: typeof initModalState,
  action: PayloadAction<FSSModal.FSSModalType>
) {
  state.activeModalType = action.payload
}

function resetModalAction() {
  return initModalState
}

export const modalSlice = createSlice({
  name: 'modal',
  initialState: initModalState,
  reducers: {
    setActiveModal: setActiveModalTypeAction,
    resetModal: resetModalAction,
  },
})

export const selectSelf = (state: Redux.RootState) => state.modal

export const activeModalTypeSelector = createSelector(
  selectSelf,
  state => state.activeModalType
)

export const isDeleteModalActiveSelector = createSelector(
  selectSelf,
  state => state.activeModalType === 'delete'
)

export const isEntryDeployModalActiveSelector = createSelector(
  selectSelf,
  state => state.activeModalType === 'entry'
)

export const isOIDCModalActiveSelector = createSelector(
  selectSelf,
  state => state.activeModalType === 'OIDC'
)

export const isEntryTerraformAnnounceModalActiveSelector = createSelector(
  selectSelf,
  state => state.activeModalType === 'announcement'
)

export const { setActiveModal, resetModal } = modalSlice.actions

export default modalSlice.reducer
